import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';

import { DuplicateTaskEditorFormValues, FORM_LAYOUT, getFormFields, validateForm } from './config';

function Editor({
  setFormikSubmit,
  onSubmit,
  initialValues,
}: {
  setFormikSubmit: FormProps<DuplicateTaskEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<DuplicateTaskEditorFormValues>['onSubmit'];
  initialValues: DuplicateTaskEditorFormValues;
}) {
  const { t } = useTranslation(['Admin', 'Task']);

  return (
    <Form<DuplicateTaskEditorFormValues>
      fields={getFormFields(t)}
      formName="DuplicateTaskEditor"
      initialValues={initialValues}
      layout={FORM_LAYOUT}
      setSubmitRef={setFormikSubmit}
      validate={validateForm(t)}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
